// Smart Sash Admin Panel - Session Invalid Error Component
// Error state for invalid or not found registration sessions

import React from 'react';

interface SessionInvalidErrorProps {
  errorMessage?: string;
}

/**
 * Session Invalid Error Component
 * Displayed when the registration session is invalid, not found, or not active
 */
export const SessionInvalidError: React.FC<SessionInvalidErrorProps> = ({ errorMessage }) => {
  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="card shadow-lg border-0">
              <div className="card-body p-5 text-center">
                <div className="mb-4">
                  <i
                    className="fas fa-exclamation-triangle text-warning"
                    style={{ fontSize: '4rem' }}
                  ></i>
                </div>

                <h1 className="h3 mb-3 fw-bold">Session Invalid</h1>

                <p className="text-muted mb-4">
                  {errorMessage || 'Your registration session is invalid or has been revoked.'}
                </p>

                <div className="alert alert-info" role="alert">
                  <i className="fas fa-info-circle me-2"></i>
                  Please scan your RFID tag again at the registration device to receive a new
                  registration link.
                </div>

                <div className="text-center mt-4 pt-4 border-top">
                  <p className="text-muted small mb-0">
                    &copy; {new Date().getFullYear()} H. H. Hawkins Ltd.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionInvalidError;
